import { useSelector } from 'store/hooks';

export const useCanAccessCSVData = (selectedTable?: string | null): boolean =>
    useSelector((state) => {
        // We first list all the scopes the user can access.
        const userScopes = state.vision.user.scopes.map((scope) => scope.name);
        // We use it to compute the scope it can not access based on all the client scopes.
        const userRestrictedScope = state.vision.protections.filter(
            (protection) => !userScopes.includes(protection.scope),
        );
        // We get all the table the user cannot fully access.
        const restrictedAccessTablesSet = new Set(
            ...userRestrictedScope.map((protection) =>
                protection.blocks.map((metric) => metric.split('.')[0]),
            ),
        );
        // TODO StrictNullCheck : Try to remove "!"
        return !restrictedAccessTablesSet.has(selectedTable!);
    });
